import {FaInstagram} from "react-icons/fa";

export const DETAILS = {
    name: "جهان فیت",
    shortName: "جهان فیت",
    footerName: "جهان فیت",
    description: "",
    aboutFooter: "سایت جهان فیت در زمینه فروش دستگاه‌ های بدنسازی باشگاهی و تجهیزات بدنسازی فعالیت می‌کند. جهان فیت انواع دستگاه‌ های بدنسازی باشگاهی را برای استفاده در محیط خانگی یا باشگاه‌ های حرفه ‌ای به مشتریان خود عرضه می‌کند. سایت جهان فیت برای هر دستگاه مشخصات فنی، ویژگی‌ها و قیمت را به همراه تصاویر مربوطه ارائه می‌دهد تا مشتریان بتوانند بر اساس نیاز و بودجه خود، دستگاه مناسب را انتخاب کنند. جهان فیت همچنین تجهیزات جانبی مرتبط با سازه کراسفیت را نیز عرضه می‌کند.",
    shortAbout: "سایت جهان فیت در زمینه فروش دستگاه‌ های بدنسازی باشگاهی و تجهیزات بدنسازی فعالیت می‌کند. جهان فیت انواع دستگاه‌ های بدنسازی باشگاهی را برای استفاده در محیط خانگی یا باشگاه‌ های حرفه ‌ای به مشتریان خود عرضه می‌کند. سایت جهان فیت برای هر دستگاه مشخصات فنی، ویژگی‌ها و قیمت را به همراه تصاویر مربوطه ارائه می‌دهد تا مشتریان بتوانند بر اساس نیاز و بودجه خود، دستگاه مناسب را انتخاب کنند. جهان فیت همچنین تجهیزات جانبی مرتبط با سازه کراسفیت را نیز عرضه می‌کند. سازه کراسفیت یک سیستم تمرینی متشکل از بندها، سیم‌ها و دستگیره‌ها است که برای تقویت عضلات مختلف بدن و افزایش استقامت و انعطاف ‌پذیری استفاده می‌ شود. جهان فیت دستگاه ‌ها و تجهیزات جانبی TRX را نیز در فروشگاه خود دارد. TRX یک سیستم تمرینی است که با استفاده از بندها، دستگیره‌ ها و وزنه‌ های بدن، تمرینات متنوعی را برای تقویت عضلات بدن و افزایش استقامت ارائه می ‌دهد. سایت جهان فیت با ارائه این تجهیزات و دستگاه‌ های بدنسازی باشگاهی، به علاقمندان به ورزش و بدنسازی امکان می‌دهد تا تمرینات خود را در خانه یا باشگاه با کیفیت و حرفه ‌ای انجام دهند. همچنین، سایت با ارائه اطلاعات و مشخصات فنی دقیق درباره محصولات، به مشتریان کمک می‌کند تا انتخاب صحیحی را بر اساس نیازها و بودجه خود داشته باشند. جهان فیت دستگاه‌ های بدنسازی تولید شده در ایران را نیز در فروشگاه خود عرضه می‌کند. این دستگاه‌ها با استفاده از فناوری ‌های مدرن و استانداردهای بین‌المللی ساخته می‌شوند و می‌توانند تمرینات متنوعی را برای افرادی که به بدنسازی علاقه‌ مندند، فراهم کنند. این دستگاه‌ ها از کیفیت بالا و طراحی مدرن برخوردار هستند و با استفاده از آنها، می‌توانید تمرینات حرفه‌ای را انجام دهید. دستگاه هوم جیم یک سیستم تمرینی است که برای تمرینات خانگی طراحی شده است. این دستگاه‌ها کوچک و قابل حمل و نقل هستند. سایت جهان فیت دستگاه‌ های هوم جیم با کیفیت و کارایی بالا را ارائه می‌دهد تا بتوانید در خانه تمرین کنید و به اهداف بدنسازی خود برسید. ",
    veryShortAbout: "",
    link: "https://jahanfit.ir",
    mobile: ["09193056695", "09354158640"],
    phone: [""],
    email: [],
    postalCode: [],
    address: "کرج، حصارک، ابتدای خیابان گلستان حصارک، فروشگاه جهان فیت",
    supportDescription: "",
    mapIframeSrc: "https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3234.1357631797628!2d50.91585694617528!3d35.84567442186516!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMzXCsDUwJzQ3LjAiTiA1MMKwNTQnNTcuOSJF!5e0!3m2!1sen!2s!4v1710597813087!5m2!1sen!2s",
    socialMedia: [
        {
            title: 'اینستاگرام',
            value: 'jahanfit ',
            name: 'instagram',
            link: "https://instagram.com/jahanfit",
            icon: <i className="lab la-instagram"/>,
            isPrimary: true
        },
        {
            title: 'واتس اپ',
            value: '09302022777',
            name: 'whatsapp',
            link: 'https://api.whatsapp.com/send/?phone=09193056695&text&app_absent=0',
            icon: <i className="lab la-whatsapp"/>,
            isPrimary: true
        },
        {
            title: 'تلگرام',
            value: 'jahanfit',
            name: 'telegram',
            link: 'https://t.me/+V6rCCa17xPbpnZn6',
            icon: <i className="lab la-telegram-plane"/>,
            isPrimary: true
        },
        {
            title: 'ایمیل',
            value: 'jahanfit@gmail.com',
            name: 'email',
            link: 'mailto:jahanfit@gmail.com',
            icon: <i className="las la-envelope"></i>,
            isPrimary: true
        },
    ],
    services: [],
    brands: [],
    enamad: {
        link: "https://trustseal.enamad.ir/?id=475801&Code=enZO7pVDeGRMFNf9x3GMYkd5mGsuKkML",
        src: "https://trustseal.enamad.ir/logo.aspx?id=475801&Code=enZO7pVDeGRMFNf9x3GMYkd5mGsuKkML",
        code: "enZO7pVDeGRMFNf9x3GMYkd5mGsuKkML"
    },
    "samandehiLink": "",
    "ZarinpalLink": "https://www.zarinpal.com/webservice/TrustCode"
}

